module.exports = __webpack_public_path__ + "imgs/logo-color.png";